var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[(!_vm.complete)?_c('especial-project',{on:{"cancel":_vm.cancel,"accept":_vm.accept}}):_vm._e(),(_vm.complete)?_c('request-sent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }